import moment from "moment";
import {ISupportMessage} from "../../models/chatModels";

export const compareSupportMessages = (
    left: ISupportMessage,
    right: ISupportMessage,
): number => {
    const byCreatedAt = moment.utc(left.created_at).valueOf() - moment.utc(right.created_at).valueOf();

    if (byCreatedAt !== 0) {
        return byCreatedAt;
    }

    return left.id - right.id;
};

export const sortSupportMessages = (messages: ISupportMessage[]): ISupportMessage[] =>
    [...messages].sort(compareSupportMessages);
